import React from 'react';
import ReactDOM from 'react-dom';
import NavigationMenu_ProjectsLocalSettings from '../../local-settings';
import NavigationMenu_TopHeader from "../../components/top-header/top-header";
import NavigationSection from "../../../../core/model2/navigation/navigation-section";
import {NavigationSectionType} from "../../../../core/model2/navigation/@const";
import {MenuComponentProps} from "../const";
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll";
import {QuickAddItemType} from "../../../../app/quick-add/@types";
import NavigationMenuToolsCrm from "./crm-menu";
import MenuTopHeader_SearchActive from "../../components/top-header/search/search";
import {SpaceSearch} from "../../components/search/space-search";
import {SpaceUsers} from "../../../../core/model2/space/system/users";
import MainMenu_UsersSearchResults from "../users/search-results";
import MenuTopHeader_SearchButton from "../../components/top-header/search/search-button";
import {BUS_COMPANY_USERS_CHANGED} from "../../../../core/model2/company-user-new/@const";

type State = {
    // collapsedDepartments : string[],
    reRender             : boolean
}

export default class MainMenu_CRM extends React.Component<MenuComponentProps, State> {

    private animationDelay      : any
    private animShow            : boolean = false

    public navigationSection    : NavigationSection    = gd.layout.navigation.navigationStructure.get(NavigationSectionType.USERS)
    public localSettings        : NavigationMenu_ProjectsLocalSettings
    public spaceSearch          : SpaceSearch

    constructor(props:MenuComponentProps) {
        super(props);

        this.localSettings  = new NavigationMenu_ProjectsLocalSettings()
        this.spaceSearch    = new SpaceSearch(new SpaceUsers(), this.reRender)

        this.state = {
            // collapsedDepartments: this.localSettings.collapsedDepartments,
            reRender: false
        };
    }

    componentDidMount() {
        // gd.session.companyUsers.on('add remove change reset', this.reRender, this);
        gd.bus.subscribe(BUS_COMPANY_USERS_CHANGED, this, this.reRender);

        this.animationDelay = _.delay(()=>{
            this.animShow = true
            const dom = ReactDOM.findDOMNode(this);
            gd.utils.Dom.addClass(dom, 'anim-show');
        }, 25);

    }

    componentWillUnmount() {
        clearTimeout(this.animationDelay)
        // gd.session.companyUsers.off('add remove change reset', this.reRender, this);
        gd.bus.unsubscribe(this)
    }

    reRender = ()=> {
        this.setState({
            reRender: true
        });
    }

    onAddUserClick = (e:React.SyntheticEvent) => {
        if (e) e.stopPropagation();
        // this.hidePopover();
        gd.openNew(QuickAddItemType.USER, {
            type            : 'invite-user',
            organizationId  : gd.companyId
        })
    }

    render() {

        // has to be company user + to access this section
        if (!gd.ac.check.company.isUser(gd.companyId)) {
            return null
        }

        const classes = Classes('main-menu-container menu-people ui5-menu p-t-0',{
            'animation': gd.layout.shouldAnimateMenu && !this.props.noAnimation,
            'anim-show': this.animShow
        });

        const rightButtonsClasses = Classes("flex-row-right-center", {
            "w-100-percent": this.spaceSearch.isActive
        })

        return (
            <div className={classes}>
                {!this.spaceSearch.isActive &&
                    <NavigationMenu_TopHeader space={gd.spaces.crm}>
                        <div className={rightButtonsClasses}>
                            <MenuTopHeader_SearchButton className="m-r-15" spaceSearch={this.spaceSearch}/>
                        </div>
                    </NavigationMenu_TopHeader>
                }

                {this.spaceSearch.isActive &&
                    <MenuTopHeader_SearchActive spaceSearch={this.spaceSearch}/>
                }

                <VScroll ref={this.props.refScroll} className="main-menu-scroll" mutationObserverEnabled={true}>

                    {this.spaceSearch.searchValue.length > 0 &&
                        <MainMenu_UsersSearchResults spaceSearch={this.spaceSearch} />}

                    {this.spaceSearch.searchValue.length === 0 &&
                        <NavigationMenuToolsCrm navigationSection={this.navigationSection}/>
                    }

                </VScroll>
            </div>
        );
    }
}
